<template lang="pug">
    .z-freight-extra-service
        .z-freight-extra-service__container
            z-check(
                v-if="!$props.hideCheck"
                v-bind:label="$props.label"
                v-bind:name="('freight-extraservice-check-' + id)"
                v-bind:id="('freight-extraservice-check-' + id)"
                v-model="val.value"
                v-bind:value="true"
                v-bind:disabled="$props.disabled || $props.disabledCheck"
                v-bind:dirty.sync="dirtyObj.service"
            )
            z-select(
                v-if="$props.payers"
                :label="`Плательщик<br>(${$props.label})`"
                v-model="val.payer_id"
                v-bind:name="('freight-extraservice-payer-' + id)"
                v-bind:id="('freight-extraservice-payer-' + id)"
                v-bind:disabled="$props.disabled || $props.disabledPayer"
                v-bind:inline="true"
                v-bind:noMargin="true"
                v-bind:dirty.sync="dirtyObj.payer"

                v-bind:data-vv-name="('freight-extraservice-payer-' + id)"
                v-bind:data-vv-as="' '"
                v-validate="{'required': (!!val.value && $props.payerRequire)}"
                v-bind:error="errors.first(('freight-extraservice-payer-' + id))"
            )
                option(v-for="(payer, i) in $props.payers" v-bind:key="(payer.hid + '-' + i)" v-bind:value="payer.id") {{payer.name}}
</template>
<script>
    import ZButton from '@/components/ZButton';
    import ZCheck  from '@/components/ZCheck';
    import ZSelect from '@/components/ZSelect';
    import ZSelectItem from '@/components/ZSelectItem';
    export default {
        name: 'ZFreightExtraService',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        freight_id: null,
                        service_id: null,
                        payer_id:   null,
                        payer_hid:  null,
                        value: false
                    }
                },
            },
            type: {
                type: String,
                default: 'checkbox'
            },
            name: {
                type: String,
                default: 'z-input'
            },
            label: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            hideCheck: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            disabledCheck: {
                type: Boolean,
                default: false
            },
            disabledPayer: {
                type: Boolean,
                default: false
            },
            payers: {
                type: Array,
                default: () => {
                    return []
                },
                required: true
            },
            payerRequire: {
                type: Boolean,
                default: true
            },
            payerAutoDefault: {
                type: Boolean,
                default: true
            }
        },
        components: {ZButton, ZCheck, ZSelect, ZSelectItem},
        data() {
            return {
                val: {
                    id: null,
                    freight_id: null,
                    service_id: null,
                    payer_id:   null,
                    payer_hid:  null,
                    value: false
                },
                dirtyObj: {
                    payer: false,
                    service: false
                }
            }
        },
        computed: {
            id () {
                return this._uid;
            },
            defaultPayer() {
                if (!this.payers || !this.payers.length) return;
                return this.payers.find(p => !!p);
            }
        },
        watch: {
            '$props.value': {
                deep: true,
                handler(value) {
                    if (JSON.stringify(this.val) !== JSON.stringify(value)) 
                        this.val = Object.assign({}, value);
                }
            },
            'val.payer_id'(id) {
                if (!id) return;
                let selectedPayer = this.$props.payers.find(payer => payer.id == id);
                if (!selectedPayer || !selectedPayer.id) return;
                this.val.payer_hid = selectedPayer.hid;
            },
            'val': {
                deep: true,
                handler(val) {
                    this.$emit('input', val);
                    this.$emit('change', val);
                }
            },
            '$props.payers'() {
                this.setDefaultPayer();
            }
            
        },
        methods: {
            setDefaultPayer() {
                //if (!this.val || this.val.payer_id) return;
                if (!this.$props.payerAutoDefault) return;
                this.$nextTick(() => {
                    if(this.$props.value.id)         this.val.id         = this.$props.value.id;
                    if(this.$props.value.freight_id) this.val.freight_id = this.$props.value.freight_id;
                    if(this.$props.value.service_id) this.val.service_id = this.$props.value.service_id;

                    if (!this.defaultPayer) {
                        this.val.payer_id  = null;
                        this.val.payer_hid = null;
                        return;
                    }

                    if (this.val.payer_id) {
                        let exist = this.$props.payers.find(item => parseInt(item.id) === parseInt(this.val.payer_id));
                        if (exist) return;

                        this.val.payer_id  = null;
                        this.val.payer_hid = null;
                    }

                    this.val.payer_id  = this.defaultPayer.id;
                    this.val.payer_hid = this.defaultPayer.hid;
                });
            },
            validate() {
                return this.$validator.validateAll();
            }
        },
        created() {
            this.val = Object.assign({}, this.$props.value);
            this.setDefaultPayer();
        },
    }
</script>
<style lang="sass">
    .z-freight-extra-service__container
        display: flex
        align-items: center
        justify-content: flex-start
        width: 100%
        .z-check
            margin: 0 10px 0 0
            flex-shrink: 0
        .z-select
            width: 100%
        //.z-select.inline
            //label
                //width: auto
                //flex: 0
</style>


// WEBPACK FOOTER //
// ZFreightExtraService.vue?3105a4d5